import { CACHE_HEADER_ENABLED } from "@sinch/cache-helpers";
import { getMessageMediaApiUrlMiddleware } from "../../config/config";
import type { ShellUser } from "../types";
import { MmUserZod, type MmUserPartial } from "./mm.types";

export const MMFetchUserURL = `${getMessageMediaApiUrlMiddleware()}/iam/v1/jwt/userinfo`;

export const getMmUser = (token: string) =>
  window
    .fetch(MMFetchUserURL, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        [CACHE_HEADER_ENABLED]: "true",
      },
    })
    .then((r) => r.json())
    .then((data) => {
      const parsed = MmUserZod.safeParse(data);
      if (parsed.success) return parsed.data;
      const errorMessage = "Invalid response from userinfo";
      console.error(errorMessage, parsed.error);
      return data as MmUserPartial;
    })
    .then(toShellUser);

export const toShellUser = (data: unknown): ShellUser => {
  const parsed = MmUserZod.safeParse(data);
  if (!parsed.success)
    console.error("Invalid response from userinfo", parsed.error);

  const mmUser = parsed.success ? parsed.data : (data as MmUserPartial);

  return {
    id: mmUser.userId,
    name: `${mmUser.user.firstName || ""} ${mmUser.user.lastName || ""}`.trim(),
    email: mmUser.user.email,
    rights: [
      ...(mmUser.account?.features || []),
      ...mmUser.featureSet.features,
    ],
    language: undefined, // Messagemedia doesn't handle user language as of now.
    profile_image: undefined, // Couldn't find one
    roles: mmUser.roles,
    status: undefined, // Couldn't find one
    activeProject: undefined, // Couldn't find one
    account: {
      id: mmUser.accountId,
      name: mmUser.account?.company,
      country: mmUser.account?.country,
    },
    settings: {
      businessId: mmUser.account?.businessId,
      vendorId: mmUser.account?.vendorId,
      paymentType: mmUser.account?.paymentType,
      username: mmUser.user.username,
      timezone: mmUser.account?.timezone,
      defaultCountryCode: mmUser.defaultCountryCode,
    },
  };
};
